import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["renderAs", "children", "clientId", "orientation", "space"];
var _templateObject, _templateObject2;
import styled from "@emotion/styled";
import React, { forwardRef } from "react";
import { useMemo } from "react";
import { sizes } from "../../constants/spacing";
function shouldForwardProp(propName) {
  switch (propName) {
    case "orientation":
    case "sizeName":
      return false;
  }
  return true;
}

// Note: We're using double "&"" to increase specificity of the margin styles,
// which allows us to override any margins set on the Spacer's direct children
var VerticallySpacedDiv = styled("div", {
  shouldForwardProp: shouldForwardProp
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    && > * + * {\n        margin-top: ", "px;\n    }\n"])), function (props) {
  return sizes[props.sizeName];
});

/**
 * Renders child elements horizontally, with given space between them.
 */
var HorizontallySpacedDiv = styled("div", {
  shouldForwardProp: shouldForwardProp
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    && > * + * {\n        margin-left: ", "px;\n    }\n"])), function (props) {
  return sizes[props.sizeName];
});

// We need to leave this generic in here to avoid breaking changes, but it's not actually used.
// It wasn't truly constraining anything, and the union types it created was causing a lot of
// slowdown in the typecript build.
// Remove this in a major release.
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
export var Spacer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var renderAs = _ref.renderAs,
    children = _ref.children,
    clientId = _ref.clientId,
    orientation = _ref.orientation,
    space = _ref.space,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Memoizing this to ensure we won't create a new component each time.
  // withComponent returns a new component.
  var SpacerRoot = useMemo(function () {
    var TheComponent = orientation === "column" ? VerticallySpacedDiv : HorizontallySpacedDiv;
    return renderAs ? TheComponent.withComponent(renderAs) : TheComponent || "div";
  }, [renderAs, orientation]);
  return /*#__PURE__*/React.createElement(SpacerRoot, _extends({
    ref: ref,
    sizeName: space,
    orientation: orientation,
    "data-client-id": clientId
  }, rest), children);
});
Spacer.displayName = "Spacer";
//# sourceMappingURL=Spacer.js.map